import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useAtom } from "jotai";
import { Button } from "../../common";
import { selectedOrgIdAtom } from "../../../atoms";
import { useFetchOrganizationInfoQuery } from "../../../api";

type OrganizationCreateSuccessProps = {
  onViewOrganization: () => void;
};

export const OrganizationCreateSuccess = ({
  onViewOrganization,
}: OrganizationCreateSuccessProps) => {
  const [selectedOrgId] = useAtom(selectedOrgIdAtom);
  const fetchOrganizationInfoQuery = useFetchOrganizationInfoQuery(
    selectedOrgId || 0,
    { enabled: !!selectedOrgId && selectedOrgId !== 0 },
  );

  const orgName = fetchOrganizationInfoQuery.data?.name || "Your organization";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        py: 8,
        px: 4,
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 56, color: "#2e7d32", mb: 2 }} />
      <Typography sx={{ fontWeight: 600, fontSize: "20px", mb: 1 }}>
        Organization Created Successfully
      </Typography>
      <Typography sx={{ color: "#606060", mb: 0.5 }}>
        {orgName} has been set up and is ready to use.
      </Typography>
      <Typography sx={{ color: "#a6a6a6", fontSize: "14px", mb: 4 }}>
        You can now invite users, configure wash services, and start tracking
        invoices.
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          label="View Organization"
          variantType="primary"
          sx={{ padding: "0.5rem", px: "1.5rem" }}
          onClick={onViewOrganization}
        />
      </Box>
    </Box>
  );
};
